module.exports = __webpack_public_path__ + "static/img/1.ffb4789f.png";